var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixel8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(-1039 -263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(1039 263)",
    fill: "#3f4053"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pixel_Pro",
    "data-name": "Pixel Pro",
    transform: "translate(1042.5 281.5)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pixel Pro")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(1062 327)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel8);
export default __webpack_public_path__ + "static/media/pixel8.52f39ce6f8ab55d7d9bb982b1910b95f.svg";
export { ForwardRef as ReactComponent };